import React from 'react';
import { CircularProgress } from '@mui/material';

const Loader = () => {
  return (
    <div style={{ display: 'flex', justifyContent: 'center', height: '100vh', marginTop: 100 }}>
      <CircularProgress sx={{ color: "black" }} />
    </div>
  );
};

export default Loader;